const NOT_CONFIGURED = "not configured";
const UTC_INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|\+00:00)$/;

const FACT_FIELDS = [
  "fact_id",
  "revision",
  "status",
  "audience",
  "topic_key",
  "approved_text_or_typed_value",
  "source_ref",
  "source_revision",
  "owner_ref",
  "reviewer_ref",
  "valid_from",
  "valid_until",
];

function readFactField(fact, key) {
  if (!fact || typeof fact !== "object" || Array.isArray(fact)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(fact, key) || fact[key] == null) {
    return NOT_CONFIGURED;
  }
  const value = fact[key];
  if (value === "") {
    return '""';
  }
  if (key === "revision") {
    return typeof value === "number" ? value : NOT_CONFIGURED;
  }
  return value;
}

export function roofingV2KnowledgeView(body) {
  const facts = body && typeof body === "object" ? body.facts : undefined;
  if (!Array.isArray(facts)) {
    return { status: NOT_CONFIGURED, rows: [] };
  }
  const pointers = body && Array.isArray(body.pointers) ? body.pointers : [];
  const conflicts = body && Array.isArray(body.conflicts) ? body.conflicts : [];
  const inFlight = body && Array.isArray(body.in_flight_sends) ? body.in_flight_sends : [];
  return {
    status: null,
    rows: facts.map((fact) => {
      const row = {};
      FACT_FIELDS.forEach((key) => {
        row[key] = readFactField(fact, key);
      });
      const pointer = pointers.find((item) => item && item.fact_id === row.fact_id);
      row.pointer_status = pointer ? readPointerStatus(pointer.status) : NOT_CONFIGURED;
      row.published_revision = pointer
        ? readPublishedRevision(pointer.published_revision)
        : NOT_CONFIGURED;
      return row;
    }),
    conflicts: conflicts.map((conflict) => ({
      subject_ref: readConflictField(conflict, "subject_ref"),
      subject_version: readConflictField(conflict, "subject_version"),
      status: readConflictField(conflict, "status"),
    })),
    in_flight_sends: inFlight.map((send) => ({
      outbound_id: readConflictField(send, "outbound_id"),
      status: readConflictField(send, "status"),
    })),
  };
}

function readConflictField(conflict, key) {
  if (!conflict || typeof conflict !== "object" || Array.isArray(conflict)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(conflict, key) || conflict[key] == null) {
    return NOT_CONFIGURED;
  }
  const value = conflict[key];
  if (value === "") {
    return '""';
  }
  if (typeof value !== "string") {
    return NOT_CONFIGURED;
  }
  return value;
}

function readPointerStatus(value) {
  if (typeof value !== "string" || value === "") {
    return NOT_CONFIGURED;
  }
  return value;
}

function readPublishedRevision(value) {
  if (typeof value === "number" && Number.isSafeInteger(value) && value >= 0) {
    return value;
  }
  return NOT_CONFIGURED;
}

function utcMillis(value) {
  if (typeof value !== "string" || !UTC_INSTANT.test(value)) {
    return null;
  }
  const parsed = Date.parse(value);
  if (Number.isNaN(parsed)) {
    return null;
  }
  return parsed;
}

export function knowledgeWindowLabel(row, asOf) {
  const status = row && row.status;
  if (status === "draft" || status === "withdrawn") {
    return status;
  }
  if (status !== "approved") {
    return NOT_CONFIGURED;
  }
  const from = utcMillis(row.valid_from);
  const until = utcMillis(row.valid_until);
  const shownAt = utcMillis(asOf);
  if (from == null || until == null || shownAt == null) {
    return NOT_CONFIGURED;
  }
  if (shownAt < from) {
    return "scheduled";
  }
  if (shownAt >= until) {
    return "expired";
  }
  return "current";
}

export function knowledgeCustomerPreview(row, asOf) {
  const status = row && row.status;
  const audience = row && row.audience;
  if (status !== "approved" || audience !== "customer") {
    return "hidden";
  }
  const from = utcMillis(row.valid_from);
  const until = utcMillis(row.valid_until);
  const shownAt = utcMillis(asOf);
  if (from == null || until == null || shownAt == null) {
    return "hidden";
  }
  if (shownAt < from || shownAt > until) {
    return "hidden";
  }
  if (row.pointer_status !== "approved" || row.revision !== row.published_revision) {
    return "hidden";
  }
  if (typeof row.revision !== "number" || typeof row.published_revision !== "number") {
    return "hidden";
  }
  return "visible";
}
